import { useLinkTo, useNavigation } from '@react-navigation/native';
import { Image, ImageBackground, StyleSheet, Text, View, useWindowDimensions } from 'react-native';
import QRCode from 'react-native-qrcode-svg';
import theme from 'theme';

import logoHeader from 'assets/LogoHeader.png';
import backgroundImage from 'assets/error-background-desktop.png';

import Button from 'components/Button';
import StoreLinks from 'components/StoreLinks';

const APP_LINK = 'https://qrco.de/bgvkVR';
const CONTENT_HORIZONTAL_PADDING = 24;

const DESKTOP_SIZES = {
  qr: 320,
  logoWidth: 288,
  logoHeight: 63,
  titleFontSize: 25,
  titleLineHeight: 37,
  buttonHeight: 54,
};

const MOBILE_SIZES = {
  qr: 228,
  logoWidth: 192,
  logoHeight: 42,
  titleFontSize: 22,
  titleLineHeight: 29,
  buttonHeight: 53,
};

export const WatchOnApp: React.FC = () => {
  const navigation = useNavigation();
  const linkTo = useLinkTo();
  const { width } = useWindowDimensions();

  const isMobile = width < 950;
  const SIZES = isMobile ? MOBILE_SIZES : DESKTOP_SIZES;

  const availableWidth = width - CONTENT_HORIZONTAL_PADDING * 2;
  const qrSize = Math.max(140, Math.min(SIZES.qr, availableWidth));
  const scale = qrSize / SIZES.qr;

  const handleBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    linkTo('/');
  };

  return (
    <ImageBackground source={backgroundImage} style={styles.background}>
      <View style={styles.content}>
        <Image
          source={logoHeader}
          style={{
            width: SIZES.logoWidth * scale,
            height: SIZES.logoHeight * scale,
            marginBottom: 48 * scale,
          }}
          resizeMode="contain"
        />

        <Text
          style={[
            styles.title,
            {
              fontSize: Math.max(18, Math.round(SIZES.titleFontSize * scale)),
              lineHeight: Math.max(24, Math.round(SIZES.titleLineHeight * scale)),
              marginBottom: 40 * scale,
            },
          ]}>
          {/* Para acessar o conteúdo vertical, escaneie o QR Code abaixo e baixe o app Bandplay. */}
          Conteúdo exclusivo para dispositivos móveis. Baixe o Bandplay no seu celular e assista aos
          Minidramas.
        </Text>

        {/* <View style={{ marginBottom: 24 * scale }}>
          <QRCode value={APP_LINK} size={qrSize} backgroundColor="#070D31" color="#A8B4FF" />
        </View> */}

        <StoreLinks />

        <Button
          variant="solid"
          iconType="ArrowLeft"
          iconStyle={{ color: '#070D31' }}
          backgroundColor="#A8B4FF"
          borderColor="white"
          onPress={handleBack}
          style={StyleSheet.flatten([
            styles.backButton,
            { width: qrSize, height: SIZES.buttonHeight * scale },
          ])}
          textStyle={styles.backButtonText}>
          Voltar
        </Button>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: CONTENT_HORIZONTAL_PADDING,
  },
  title: {
    color: 'white',
    fontFamily: theme.fonts.inter.bold,
    textAlign: 'center',
    maxWidth: 933,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 34,
  },
  backButtonText: {
    color: '#070D31',
    fontFamily: theme.fonts.inter.bold,
    fontSize: 16,
    marginLeft: 6,
  },
});
